<template>
  <div>
    <a-dropdown :trigger="['click']" placement="bottomLeft">
      <div :class="[$style.dropdown, 'm-0', 'p-0']">
        <a-badge :count="countIsViewed(notifications)" :overflow-count="9">
          <i class="fe fe-bell" :class="$style.icon" />
        </a-badge>
      </div>
      <div slot="overlay">
        <div class="card ict__utils__shadow" style="width: 450px;">
          <div class="card-body p-0 m-2">
            <ListNotification
              :notifications="[...notifications, ...notificationsViewed]"
              :deleteNotifications="deleteNotifications"
            />
            <hr class="mt-1" />
            <a-button
              @click="goToNotifications"
              type="link"
              icon="arrow-right"
              class="border-0"
            >
              View more
            </a-button>
          </div>
        </div>
      </div>
    </a-dropdown>
  </div>
</template>

<script>
import Query from "./query";
import ListNotification from "./ListNotification";
function countIsViewed(array) {
  if (array?.length > 0) {
    return array.filter((e) => !e.isViewed).length;
  }
  return 0;
}
export default {
  components: { ListNotification },
  data() {
    return {
      notifications: [],
      notificationsViewed: [],
    };
  },
  methods: {
    countIsViewed,
    onGetNotificationsViewed() {
      this.$apollo
        .query({
          query: Query.notifications,
          variables: { isViewed: true, limit: 10 },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.notifications?.length >= 0) {
            this.notificationsViewed = [...data.notifications];
          }
        })
        .catch((err) => {
          console.error("Cannot get list notifications", err);
        });
    },
    deleteNotifications(items, callback) {
      const { notifications } = this;
      for (const item of items) {
        const itemIndex = notifications.findIndex((e) => e.id === item.id);
        if (+itemIndex >= 0) {
          notifications.splice(itemIndex, 1);
        }
      }
      this.notifications = [...notifications];
      if (callback && typeof callback === "function") {
        callback();
      }
    },
    subscribeToMore() {
      this.$apollo.queries.notifications.subscribeToMore({
        document: Query.subNotification,
        // Mutate the previous result
        updateQuery: (previousResult, { subscriptionData: { data } }) => {
          // Here, return the new result from the previous with the new data
          const { notification } = data;
          if (notification && notification.mutation === "CREATED") {
            this.notifications.unshift(notification.node);
          }
        },
      });
    },
    goToNotifications() {
      this.$router.push({ name: "notifications" });
    },
  },
  created() {
    this.$apollo.addSmartQuery("notifications", {
      query: Query.notifications,
      variables: { isViewed: false, limit: 10 },
      fetchPolicy: "no-cache",
    });
    this.onGetNotificationsViewed();

    // this.subscribeToMore();
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
